import { memo } from 'react';
import loadable from '../../utils/loadable';

const AuthenticationMainWrapper = loadable(() => import('../../components/AuthenticationComponents/AuthenticationMainWrapper'));

export const SignIn = (props) => (
  <AuthenticationMainWrapper hasBigScreenDesign signInPage {...props} />
);

export default memo(SignIn);
